/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {PncTypeEnum} from './pnc-type.enum';

export class PncTypeEnumMapper {
    private constructor() {
    }

    static fromString(input: string): PncTypeEnum {
        let pncType = PncTypeEnum.UNKNOWN;

        if (Object.values(PncTypeEnum)
                .includes(input as PncTypeEnum)) {
            pncType = input as PncTypeEnum;
        }

        return pncType;
    }
}
